import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_INPUT_CHANGED_SCHEMA = Object.freeze({});
const RECORD = generateSchema(TRACKING_INPUT_CHANGED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_INPUT_CHANGED_SCHEMA);

export class InputChangedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.input_changed;
  }

  get properties() {
    return this.toJS();
  }
}
